var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_1176)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3_1176)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89059 5.24591C3.01932 5.51977 3.33794 6.0612 3.33794 6.0612L7.0214 0L3.42644 2.4988C3.21224 2.64105 3.03649 2.83359 2.91472 3.05943C2.75099 3.40014 2.664 3.77235 2.65983 4.15001C2.65566 4.52767 2.73441 4.90168 2.89059 5.24591Z",
    fill: "#2C99E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.43116 7.24176C1.47175 7.82148 1.63632 8.38596 1.91384 8.89728C2.19137 9.40864 2.57545 9.85506 3.04036 10.2066L7.0167 12.9665C7.0167 12.9665 4.52886 9.39773 2.43047 5.84654C2.21803 5.47137 2.07522 5.06117 2.00887 4.63559C1.97949 4.44288 1.97949 4.24686 2.00887 4.05414C1.95415 4.15506 1.84794 4.36168 1.84794 4.36168C1.63518 4.79363 1.49027 5.2555 1.41829 5.73122C1.37686 6.23406 1.38116 6.73963 1.43116 7.24176Z",
    fill: "#2C99E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5756 7.72072C11.4469 7.44676 11.1282 6.90538 11.1282 6.90538L7.44482 12.9666L11.0397 10.4693C11.254 10.3271 11.4297 10.1346 11.5515 9.90868C11.7154 9.56784 11.8026 9.19536 11.8067 8.81735C11.8109 8.43938 11.732 8.06507 11.5756 7.72072Z",
    fill: "#2C99E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0352 5.72482C12.9947 5.14505 12.8301 4.58059 12.5525 4.06924C12.275 3.55791 11.8909 3.11149 11.4261 2.75989L7.44971 0C7.44971 0 9.93596 3.5688 12.0359 7.11999C12.2478 7.49526 12.3901 7.90552 12.4559 8.33092C12.4853 8.52368 12.4853 8.71965 12.4559 8.91236C12.5106 8.81151 12.6169 8.60488 12.6169 8.60488C12.8296 8.17289 12.9746 7.71098 13.0465 7.23531C13.0885 6.73253 13.0847 6.22695 13.0352 5.72482Z",
    fill: "#2C99E0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91484 3.05943C3.03661 2.83359 3.21236 2.64105 3.42657 2.4988L7.02152 0L3.33806 6.06282C3.33806 6.06282 3.01622 5.52139 2.8907 5.24748C2.73429 4.90306 2.6554 4.52876 2.65957 4.1508C2.66374 3.77284 2.75087 3.40036 2.91484 3.05943ZM1.43116 7.24176C1.47175 7.82148 1.63632 8.38596 1.91384 8.89728C2.19137 9.40865 2.57545 9.85507 3.04036 10.2067L7.0167 12.9665C7.0167 12.9665 4.52886 9.39773 2.43047 5.84655C2.21803 5.47137 2.07522 5.06118 2.00887 4.6356C1.97949 4.44289 1.97949 4.24687 2.00887 4.05415C1.95415 4.15506 1.84794 4.36169 1.84794 4.36169C1.63518 4.79364 1.49027 5.2555 1.41829 5.73122C1.37686 6.23411 1.38116 6.73964 1.43116 7.24176ZM11.5691 7.72225C11.4404 7.44834 11.1218 6.90696 11.1218 6.90696L7.44473 12.9665L11.0397 10.4693C11.2538 10.3271 11.4296 10.1346 11.5514 9.90869C11.7154 9.5678 11.8025 9.19532 11.8066 8.8173C11.8108 8.43939 11.732 8.06508 11.5756 7.72068L11.5691 7.72225ZM13.0286 5.72645C12.988 5.14663 12.8235 4.58219 12.5459 4.07085C12.2684 3.55951 11.8844 3.1131 11.4194 2.7615L7.44956 0C7.44956 0 9.93576 3.5688 12.0357 7.11999C12.2476 7.49526 12.3899 7.90552 12.4558 8.33092C12.4851 8.52368 12.4851 8.71965 12.4558 8.91236C12.5105 8.81151 12.6167 8.60488 12.6167 8.60488C12.8294 8.17289 12.9744 7.71098 13.0463 7.23531C13.0883 6.73253 13.0846 6.22695 13.035 5.72482L13.0286 5.72645Z",
    fill: "#4A73F7"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_1176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.72998)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3_1176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.72998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.b01e3be2f2d3d077b26abf9c04c4f731.svg";
export { ForwardRef as ReactComponent };